import React from 'react';
import { ListItem, useListContext } from '../../ListContext';
import { BaseRowProps } from './Row';
import CollapsibleRow from './CollapsibleRow';
import { CollapsibleRowStorageProps } from './collapsibleRowService';
import { get } from 'lodash';

export interface TableBodyWithGroupingProps extends BaseRowProps {
  children: React.ReactElement | React.ReactElement[];
  childrenSource?: string;
  isRequiredChildrenSource?: boolean;
  toggleSource?: string;
  toggleProp?: string;
  collapsibleRowStorageProps?: CollapsibleRowStorageProps;
  CustomChildTemplate?: React.ReactElement | React.ReactElement[];
  isShowCollapsible?: (data: ListItem) => boolean;
}

const TableBodyWithGrouping = ({
  children,
  rowProps = {},
  buttons = [],
  rowKeySource = 'id',
  childrenSource,
  isRequiredChildrenSource = true,
  toggleSource,
  toggleProp,
  collapsibleRowStorageProps,
  CustomChildTemplate,
  isShowCollapsible,
}: TableBodyWithGroupingProps) => {
  const { data: { items = [] } = {} } = useListContext();

  const getChildrenContent = (item: ListItem, level: number) => {
    if (!isRequiredChildrenSource) return CustomChildTemplate;
    if (!childrenSource || !get(item, childrenSource)?.length) return null;
    return CustomChildTemplate || getRows(get(item, childrenSource), level + 1);
  };

  const getRows = (data: any[], level = 0): any[] => {
    return data.map((item: ListItem) => {
      return (
        <CollapsibleRow
          key={`row-${item[rowKeySource]}-${level}`}
          data={item}
          template={children}
          buttons={buttons}
          rowProps={rowProps}
          rowKeySource={rowKeySource}
          toggleSource={toggleSource}
          toggleProp={toggleProp}
          level={level}
          collapsibleRowStorageProps={collapsibleRowStorageProps}
        >
          {getChildrenContent(item, level)}
        </CollapsibleRow>
      );
    });
  };

  return <tbody>{getRows(items)}</tbody>;
};

export default TableBodyWithGrouping;
